import { Skeleton } from '@/components/ui/skeleton';

interface SkeletonStackProps {
  count: number;
  className: string;
  wrapperClassName?: string;
}

const SkeletonStack = ({ count, className, wrapperClassName }: SkeletonStackProps) => {
  return (
    <div className={wrapperClassName ?? 'flex flex-col gap-3'}>
      {Array.from({ length: count }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Skeleton key={`skeleton-${index}`} className={className} />
      ))}
    </div>
  );
};

export default SkeletonStack;
